(function () {
  var brandRed = '#D20838';
  var styleId = 'swym-anchor-overrides';

  function ensureSwymStyleTag() {
    if (document.getElementById(styleId)) return;

    var style = document.createElement('style');
    style.id = styleId;
    style.textContent =
      '#swym-plugin #swym-anchor a.swym-background-color,' +
      '#swym-hosted-plugin #swym-anchor a.swym-background-color,' +
      '#swym-anchor a.swym-background-color,' +
      '#swym-anchor a#notepad-anchor-title{' +
      'background:#fff!important;background-color:#fff!important;' +
      'border:2px solid ' + brandRed + '!important;color:' + brandRed + '!important;box-shadow:none!important}' +
      '#swym-anchor .swym-icon::before{color:' + brandRed + '!important;-webkit-text-fill-color:' + brandRed + '!important}' +
      '#swym-anchor .swym-anchor-badge{background:' + brandRed + '!important;border:1px solid ' + brandRed + '!important;color:#fff!important}';
    document.head.appendChild(style);
  }

  function styleSwymAnchor() {
    var anchor = document.getElementById('swym-anchor');
    if (!anchor) return false;

    ensureSwymStyleTag();

    var link = anchor.querySelector('.swym-background-color, #notepad-anchor-title');
    if (link) {
      link.style.setProperty('background-color', '#ffffff', 'important');
      link.style.setProperty('background', '#ffffff', 'important');
      link.style.setProperty('border', '2px solid ' + brandRed, 'important');
      link.style.setProperty('color', brandRed, 'important');
      link.style.setProperty('box-shadow', 'none', 'important');
    }

    anchor.querySelectorAll('.swym-icon').forEach(function (icon) {
      icon.style.setProperty('color', brandRed, 'important');
    });

    var badge = anchor.querySelector('.swym-anchor-badge');
    if (badge) {
      badge.style.setProperty('background-color', brandRed, 'important');
      badge.style.setProperty('border', '1px solid ' + brandRed, 'important');
      badge.style.setProperty('color', '#ffffff', 'important');
    }

    return true;
  }

  function watchSwymAnchor() {
    if (styleSwymAnchor()) return;

    var observer = new MutationObserver(function () {
      styleSwymAnchor();
    });

    observer.observe(document.documentElement, { childList: true, subtree: true });
    window.setTimeout(function () {
      observer.disconnect();
    }, 20000);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', watchSwymAnchor);
  } else {
    watchSwymAnchor();
  }
})();
